export default __webpack_public_path__ + "static/media/0170.58812818.jpg";